(function ($) {
    $("document").ready(setup);

    function setup() {
        sliderTestimonial();
    }

    // Fonction du slider d'accueil
    function sliderHome() {
        $(".slider-tabs .slider-home-slides").slick({
            lazyLoad: 'ondemand',
            autoplay: true,
            slidesToShow: 1,
            infinite: false,
            speed: 2000,
            dots: false,
            slidesToScroll: 1,
            arrows: false,
            asNavFor: ".slider-home-footer-slides"
        });
        $(".slider-tabs .slider-home-footer-slides").slick({
            lazyLoad: 'ondemand',
            slidesToShow: 3,
            slidesToScroll: 1,
            asNavFor: ".slider-home-slides",
            dots: false,
            arrows: false,
            focusOnSelect: false
        });
        $(".slider-arrow .slider-home-slides").slick({
            lazyLoad: 'ondemand',
            autoplay: true,
            slidesToShow: 1,
            infinite: false,
            speed: 2000,
            dots: true,
            slidesToScroll: 1,
            arrows: true
        });
    }

    // Fonction du slider de produit (pour afficher les visuels dans le slider au clic sur un des onglets)
    function sliderProduct() {
        $("body").on("click", ".ul-slider-tab-footer li", function (e) {
            var tabID = $(this).attr("data-slide");
            $(".blockslidsproduct-section-" + tabID)
                .find(".slider-product")
                .slick("refresh");
        });

        $(".slider-product")
            .not(".slick-initialized")
            .slick({
                lazyLoad: 'ondemand',
                autoplay: true,
                slidesToShow: 1,
                infinite: true,
                speed: 500,
                dots: true,
                slidesToScroll: 1,
                arrows: true,
                fade: true
            });
    }

    // Fonction du slider accueil mini simple
    function sliderHomeMini() {
        $(".slider-arrow-mini .slider-home-slides").slick({
            lazyLoad: 'ondemand',
            autoplay: true,
            slidesToShow: 1,
            infinite: true,
            speed: 2000,
            dots: false,
            slidesToScroll: 1,
            arrows: true
        });
    }

    // Fonction du slider des témoignages
    function sliderTestimonial() {
        $("body").on("click", ".ul-slider-tab-footer li", function (e) {
            $(".blocktestimonial .blocktestimonial-block").slick("refresh");
        });

        $(".blocktestimonial .blocktestimonial-block")
            .not(".slick-initialized")
            .slick({
                lazyLoad: 'ondemand',
                autoplay: false,
                dots: true,
                infinite: true,
                speed: 500,
                fade: true,
                cssEase: "linear",
                arrows: true,
                dots: false
            });
    }

    // Fonction pour initialiser le slider des realisations, si on est sur un onglet ou non (ex fiche pdt)
    function sliderPhotoRealizations() {
        $("body").on("click", ".ul-slider-tab-footer li", function (e) {
            var tabID = $(this).attr("data-slide");
            $("#section-" + tabID)
                .find(".slider-image-realization")
                .slick("refresh");
        });

        $(".slider-image-realization")
            .not(".slick-initialized")
            .slick({
                lazyLoad: 'ondemand',
                autoplay: false,
                slidesToShow: 1,
                infinite: true,
                speed: 2000,
                dots: true,
                slidesToScroll: 1,
                arrows: true
            });
    }

    // Fonction pour initialiser le slider des options, si on est sur un onglet ou non (ex fiche pdt)
    function sliderOptions() {
        $("body").on("click", ".ul-slider-tab-footer li", function (e) {
            var tabID = $(this).attr("data-slide");

            $("#section-" + tabID)
                .find(".slider-text-photo")
                .slick("refresh");
        });

        $(".slider-text-photo").slick({
            lazyLoad: 'ondemand',
            infinite: true,
            slidesToShow: 1,
            lidesToScroll: 1,
            arrow: true,
            variableWidth: false,
            dots: true
        });
    }

    // Fonction du slider photo
    function sliderPhoto() {
        $("body").on("click", ".ul-slider-tab-footer li", function (e) {
            var tabID = $(this).attr("data-slide");

            $("#section-" + tabID)
                .find(".slider-photo")
                .slick("refresh");
        });

        $(".slider-photo").slick({
        lazyLoad: 'ondemand',
        infinite: false,
        slidesToShow: 5,
        speed: 500,
        variableWidth: false,
        dots: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 5
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
            }
          }
        ]
      });
    }

})(jQuery);
